import { Link } from "react-router-dom";
import styles from "../styles/Breadcrumb.module.scss";

/**
 * Breadcrumb de navegação com link pai e página atual.
 * @param {string} paiLabel - Texto do link pai
 * @param {string} paiTo - Rota do link pai
 * @param {string} atual - Texto da página atual
 */
function Breadcrumb({ paiLabel, paiTo, atual }) {
  return (
    <div className={styles.breadcrumb}>
      <Link to={paiTo} className={styles.pai}>{paiLabel}</Link>
      <span class="material-symbols-outlined" style={{ fontSize: '20px' }}>chevron_forward</span>
      <span className={styles.atual}>{atual}</span>
    </div>
  );
}

export default Breadcrumb;
